var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"breadcrumbs"},[_c('div',{staticClass:"container"},[_vm._t("breadcrumbs")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/BreadCrumbs.vue